// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* ESG 2025 Scoped Container Reset & Base Styles */
.NjNeaco9pT2mMVtjvILt *,
.doKNNRaKYNqolhoS71KY *,
.EmEbPptjAZccLR6PE6JQ *,
.UXF2y4BdHYvb8F7COXTd *,
.iEEDyLFKEESTjWhHWIMV * {
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
    scroll-padding-top: 90px;
}

.NjNeaco9pT2mMVtjvILt,
.doKNNRaKYNqolhoS71KY {
    font-family: 'Noto Sans KR', sans-serif;
    color: #333;
    background-color: #fcfdfe;
    line-height: 1.6;
}

/* ESG Main Container */
.NjNeaco9pT2mMVtjvILt {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 20px 80px 20px;
}

.EmEbPptjAZccLR6PE6JQ {
    margin-bottom: 40px;
    position: relative;
}

/* Navigation Bar */
.UXF2y4BdHYvb8F7COXTd {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.b_bPl39pd46fGG9ur5UF {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
}

.PLOd8R_ahobqzEIAEj4f {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 20px;
    font-weight: 800;
    color: #1b458f;
    text-decoration: none;
}

.ttacMyPbbzuWtvDZaRN3 {
    background: linear-gradient(135deg, #1b458f 0%, #2e7d32 100%);
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    padding: 3px 8px;
    border-radius: 12px;
    text-transform: uppercase;
}

.ho3ZpUl9YKG4bydIumSw {
    display: flex;
    align-items: center;
    gap: 8px;
    list-style: none;
}

.voiWt6LKIQLvHsNfLwtI {
    background: transparent;
    border: none;
    padding: 10px 16px;
    font-size: 15px;
    font-weight: 600;
    color: #64748b;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    gap: 6px;
}

.voiWt6LKIQLvHsNfLwtI:hover {
    color: #1b458f;
    background-color: #f1f5f9;
}

.voiWt6LKIQLvHsNfLwtI.hXBcTCNFIlq1Z55KAKWQ {
    color: #ffffff;
    background-color: #1b458f;
    box-shadow: 0 2px 8px rgba(27, 69, 143, 0.25);
}

.voiWt6LKIQLvHsNfLwtI.hXBcTCNFIlq1Z55KAKWQ.XQoMOpNStr3oOZDAt_DZ {
    background-color: #2e7d32;
    box-shadow: 0 2px 8px rgba(46, 125, 50, 0.25);
}

.voiWt6LKIQLvHsNfLwtI.hXBcTCNFIlq1Z55KAKWQ.xiCWRl5JAriZJTpUIv_m {
    background-color: #e65100;
    box-shadow: 0 2px 8px rgba(230, 81, 0, 0.25);
}

.voiWt6LKIQLvHsNfLwtI.hXBcTCNFIlq1Z55KAKWQ.RtNab_UAcUFeGYhk3RTs {
    background-color: #1b458f;
    box-shadow: 0 2px 8px rgba(27, 69, 143, 0.25);
}

/* Category Header Banner */
.iEEDyLFKEESTjWhHWIMV {
    margin: 40px 0 30px 0;
    padding: 24px 30px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
}

.iEEDyLFKEESTjWhHWIMV.ilP2VJMhq_nupwpjsosK {
    background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%);
}

.iEEDyLFKEESTjWhHWIMV.GEVcz5CGC2FBCgbo8dym {
    background: linear-gradient(135deg, #f57c00 0%, #e65100 100%);
}

.iEEDyLFKEESTjWhHWIMV.DGhO1SqUyFj0kQPy0CQl {
    background: linear-gradient(135deg, #1b458f 0%, #0d2757 100%);
}

.iEEDyLFKEESTjWhHWIMV h2 {
    font-size: 24px;
    font-weight: 700;
    margin: 0;
}

.iEEDyLFKEESTjWhHWIMV p {
    font-size: 15px;
    opacity: 0.9;
    margin: 4px 0 0 0;
}

/* Mobile Responsiveness */
@media screen and (max-width: 768px) {
    .b_bPl39pd46fGG9ur5UF {
        flex-direction: column;
        height: auto;
        padding: 12px 16px;
        gap: 12px;
    }

    .ho3ZpUl9YKG4bydIumSw {
        width: 100%;
        overflow-x: auto;
        padding-bottom: 4px;
        white-space: nowrap;
    }

    .voiWt6LKIQLvHsNfLwtI {
        font-size: 13px;
        padding: 8px 12px;
    }

    .NjNeaco9pT2mMVtjvILt {
        padding: 10px 10px 40px 10px;
    }
}

.tB_zs7vI1DMhL4PUEFoM {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 50px;
    row-gap: 0;
}

.t8Swbqs5Kr4TUHE4fmJl {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    padding: 20px 0;
    border-bottom: 1px solid #e0e0e0;
    box-sizing: border-box;
}

/* 숫자 폰트 크기 및 스타일 명확히 고정 */
.VCy6RldNqQLtamxwzOJ3 {
    font-size: 46px !important;
    font-weight: 700 !important;
    line-height: 1 !important;
    min-width: 55px !important;
}

.zqzZh6CT2PRsK_widcKI h4 {
    font-size: 20px !important;
    font-weight: 700 !important;
    margin: 0 0 8px 0 !important;
    word-break: keep-all !important;
}

.zqzZh6CT2PRsK_widcKI p {
    font-size: 16px !important;
    color: #555555 !important;
    line-height: 1.55 !important;
    margin: 0 0 4px 0 !important;
    word-break: keep-all !important;
}

.zqzZh6CT2PRsK_widcKI p:last-child {
    margin-bottom: 0 !important;
}

/* 모바일 반응형 */
@media screen and (max-width: 768px) {
    .tB_zs7vI1DMhL4PUEFoM {
        grid-template-columns: 1fr !important;
        column-gap: 0 !important;
    }
}

/*
     * ESG2025 CSS — 통합 스타일
     * 대제목(h3): 20px | 본문(p/li/div): 15px | 캡션/부가설명(span): 13px
     */

/* === 기본 레이아웃 === */
.NjNeaco9pT2mMVtjvILt .U9LQuJB1rawoRb7WlqWZ,
.doKNNRaKYNqolhoS71KY .U9LQuJB1rawoRb7WlqWZ {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
}

.rXE8ouP9R8tw4qVuYA02 {
    color: #f57c00;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 8px;
}

.lMYl5KSyohB8jQFVyFyT {
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 16px;
}

.Tr88lkDuOXjUj2nQYWXY {
    font-size: 26px;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 40px;
}

/* === 섹션 === */
.nUep5e5mWSIHfmwTteZs {
    margin-top: 20px;
    margin-bottom: 60px;
}

.nUep5e5mWSIHfmwTteZs>p {
    margin-bottom: 20px;
}

.nUep5e5mWSIHfmwTteZs hr {
    margin: 40px 0;
    border-top: 1px dashed #ccc;
    border-bottom: none;
    border-left: none;
    border-right: none;
}

/* === 폰트 크기 기준 === */
/* 섹션/블록 대제목 */
.U9LQuJB1rawoRb7WlqWZ h3,
.nUep5e5mWSIHfmwTteZs h3 {
    font-size: 20px;
    font-weight: 700;
}

/* 소제목 */
.nUep5e5mWSIHfmwTteZs h4,
.a2nrqCXYBwefhCrTin2R h4 {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 8px;
}

/* 본문 텍스트 */
.U9LQuJB1rawoRb7WlqWZ p,
.U9LQuJB1rawoRb7WlqWZ li,
.U9LQuJB1rawoRb7WlqWZ div,
.nUep5e5mWSIHfmwTteZs p,
.nUep5e5mWSIHfmwTteZs li,
.a2nrqCXYBwefhCrTin2R p {
    font-size: 15px;
}

/* 이미지 캡션 및 부가 설명 */
.U9LQuJB1rawoRb7WlqWZ>span,
.U9LQuJB1rawoRb7WlqWZ span,
.nUep5e5mWSIHfmwTteZs span,
.YMCfyIntkNdw1x5inljQ {
    font-size: 13px;
    color: #727272;
}

.YMCfyIntkNdw1x5inljQ {
    text-align: center;
    color: #2e7d32;
    margin-top: 5px;
}

/* === 이미지 그리드 === */
.NpK92JSzlMsYxSSWKquX {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    justify-content: center;
    align-items: center;
    width: 100% !important;
}

.NpK92JSzlMsYxSSWKquX img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 !important;
}

.nUep5e5mWSIHfmwTteZs .NpK92JSzlMsYxSSWKquX {
    margin-top: 20px;
}

.nUep5e5mWSIHfmwTteZs .NpK92JSzlMsYxSSWKquX img {
    width: 100%;
}

/* === 플렉스 텍스트 레이아웃 === */
.zQ1cOKIH4bVCzildyUOl {
    margin-top: 0;
    display: flex;
    gap: 20px;
    align-items: center;
    margin: 40px 0;
    flex: 1;
}

.LUqzsQhwbdbap5V72tun {
    display: flex;
    gap: 10px;
}

/* === 반응형 === */
@media screen and (max-width: 768px) {
    .zQ1cOKIH4bVCzildyUOl {
        flex-direction: column;
    }

    .LUqzsQhwbdbap5V72tun {
        justify-content: flex-start;
    }

    .NpK92JSzlMsYxSSWKquX img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }

    .zQ1cOKIH4bVCzildyUOl h3 {
        font-size: 20px;
        margin-bottom: 12px;
    }

    .zQ1cOKIH4bVCzildyUOl p {
        line-height: 1.6;
    }

    .LUqzsQhwbdbap5V72tun {
        display: flex;
        gap: 12px;
        flex: 1;
        justify-content: flex-end;
    }

    .NpK92JSzlMsYxSSWKquX {
        flex: 1;
    }
}

/* ==========================================
 * ESG2025 WordPress Layout Style
 * ========================================== */

.doKNNRaKYNqolhoS71KY {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
}

/* 좌우 2컬럼 레이아웃 */
.A1CozaXTET1mGIP1bhQh {
    display: flex;
    gap: 30px;
    align-items: stretch;
    /* 오른쪽 이미지가 왼쪽 콘텐츠 높이에 맞춰 늘어남 */
    margin-top: 20px;
    margin-bottom: 60px;
}

/* 왼쪽 콘텐츠 칼럼 (제목 + 텍스트 + 그래프) */
.a2nrqCXYBwefhCrTin2R {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.a2nrqCXYBwefhCrTin2R h4 {
    font-size: 18px;
    font-weight: 700;
    color: #3b5998;
    /* 이미지 레이아웃의 헤더 색상 반영 */
    margin-top: 0;
    margin-bottom: 20px;
}

.a2nrqCXYBwefhCrTin2R p {
    font-size: 15px;
    line-height: 1.65;
    color: #333333;
    margin-bottom: 20px;
}

/* 그래프 이미지 스타일 */
.r5Gr86ApQNiFdZHnkzzL {
    margin-top: 10px;
    width: 100%;
}

.r5Gr86ApQNiFdZHnkzzL img {
    width: 100%;
    height: auto;
    display: block;
    border: 1px solid #e0e0e0;
}

/* 오른쪽 이미지 칼럼 */
.g3DCX3QKOrSp8QCoQVkS {
    flex: 1;
    display: flex;
}

.g3DCX3QKOrSp8QCoQVkS img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 영역 전체를 꽉 채우도록 설정 */
    display: block;
    border-radius: 2px;
}

/* 반응형 모바일 설정 */
@media screen and (max-width: 992px) {
    .A1CozaXTET1mGIP1bhQh {
        flex-direction: column;
    }

    .g3DCX3QKOrSp8QCoQVkS {
        min-height: 350px;
        /* 모바일 전환 시 이미지 높이 확보 */
    }
}

@media screen and (max-width: 768px) {

    .UET36Lsvp5ZOl68RkTyd,
    .q6ii17KgzQNz5zI7oXR0 {
        flex-direction: column !important;
    }
}

@media screen and (max-width: 768px) {

    .ZreuXc2YbgrTpUNMU0rW,
    .yMo7iWTqN34TptJQDzgw {
        grid-template-columns: 1fr !important;
    }
}

@media screen and (max-width: 768px) {
    .RbBz3ximQOoZfzCuNSbk {
        flex-direction: column !important;
        gap: 30px !important;
    }
}

@media screen and (max-width: 992px) {
    ._ViBHzTZ4B9GqNWJ_eA0 {
        flex-direction: column !important;
    }
}

@media screen and (max-width: 768px) {
    .r0gjU4j9aHv3wT9eyesH {
        grid-template-columns: repeat(2, 1fr) !important;
    }
}

@media screen and (max-width: 992px) {
    .t9rm8rL1AO8GglQ4NB9K {
        flex-direction: column !important;
    }
}

/* ============================================
 * ESG2025 Social — 통합 스타일 기준
 * ============================================ */

/* 섹션/블록 대제목 */
.nUep5e5mWSIHfmwTteZs h3,
.U9LQuJB1rawoRb7WlqWZ h3 {
    font-size: 20px;
    font-weight: 700;
    color: #2b4c9b;
}

/* 소제목 */
.nUep5e5mWSIHfmwTteZs h4,
.U9LQuJB1rawoRb7WlqWZ h4 {
    font-size: 18px;
    font-weight: 700;
    color: #2b4c9b;
}

/* 본문 텍스트 */
.nUep5e5mWSIHfmwTteZs p,
.nUep5e5mWSIHfmwTteZs li,
.nUep5e5mWSIHfmwTteZs div,
.U9LQuJB1rawoRb7WlqWZ p,
.U9LQuJB1rawoRb7WlqWZ li {
    font-size: 15px;
}

/* 이미지 캡션 및 부가 설명 */
.nUep5e5mWSIHfmwTteZs span,
.U9LQuJB1rawoRb7WlqWZ span {
    font-size: 13px;
}

/* 이미지 border-radius 전역 제거 */
.nUep5e5mWSIHfmwTteZs img,
.U9LQuJB1rawoRb7WlqWZ img {
    border-radius: 0 !important;
}

/* 섹션 상하 여백 */
.nUep5e5mWSIHfmwTteZs {
    padding-top: 40px;
    padding-bottom: 40px;
}

.NjNeaco9pT2mMVtjvILt section.U9LQuJB1rawoRb7WlqWZ,
.doKNNRaKYNqolhoS71KY section.U9LQuJB1rawoRb7WlqWZ {
    padding-top: 40px;
    padding-bottom: 40px;
}

/* h3/h4 상단 여백 */
.nUep5e5mWSIHfmwTteZs h3,
.U9LQuJB1rawoRb7WlqWZ h3 {
    margin-top: 20px !important;
    margin-bottom: 8px !important;
}

.nUep5e5mWSIHfmwTteZs h4,
.U9LQuJB1rawoRb7WlqWZ h4 {
    margin-top: 16px !important;
    margin-bottom: 6px !important;
}

/* ============================================
 * ESG2025 Governance — 통합 스타일 기준
 * ============================================ */

/* 섹션/블록 대제목 */
.nUep5e5mWSIHfmwTteZs h3,
.U9LQuJB1rawoRb7WlqWZ h3 {
    font-size: 20px;
    font-weight: 700;
    color: #2b4c9b;
    margin-top: 30px;
    margin-bottom: 10px;
}

/* 소제목 */
.nUep5e5mWSIHfmwTteZs h4,
.U9LQuJB1rawoRb7WlqWZ h4 {
    font-size: 18px;
    font-weight: 700;
    color: #2b4c9b;
    margin-top: 25px;
    margin-bottom: 8px;
}

/* 본문 텍스트 */
.nUep5e5mWSIHfmwTteZs p,
.nUep5e5mWSIHfmwTteZs li,
.nUep5e5mWSIHfmwTteZs div,
.U9LQuJB1rawoRb7WlqWZ p,
.U9LQuJB1rawoRb7WlqWZ li {
    font-size: 15px;
}

/* 이미지 캡션 및 부가 설명 */
.nUep5e5mWSIHfmwTteZs span,
.U9LQuJB1rawoRb7WlqWZ span {
    font-size: 13px;
}

/* 이미지 border-radius 전역 제거 */
.nUep5e5mWSIHfmwTteZs img,
.U9LQuJB1rawoRb7WlqWZ img {
    border-radius: 0 !important;
}

/* 섹션 상하 여백 */
.nUep5e5mWSIHfmwTteZs {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
}

.NjNeaco9pT2mMVtjvILt section.U9LQuJB1rawoRb7WlqWZ,
.doKNNRaKYNqolhoS71KY section.U9LQuJB1rawoRb7WlqWZ {
    padding-top: 40px;
    padding-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./static/css/esg2025.module.css"],"names":[],"mappings":";;AAEA,kDAAkD;AAClD;;;;;IAKI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;;IAEI,uCAAuC;IACvC,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,qCAAqC;IACrC,2BAA2B;IAC3B,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA,2BAA2B;AAC3B;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI;QACI,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI;QACI,qCAAqC;QACrC,wBAAwB;IAC5B;AACJ;;AAEA;;;MAGM;;AAEN,oBAAoB;AACpB;;IAEI,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB,cAAc;AACd;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA,QAAQ;AACR;;IAEI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,WAAW;AACX;;;;;;IAMI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;;;;IAII,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,OAAO;AACX;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,OAAO;QACP,yBAAyB;IAC7B;;IAEA;QACI,OAAO;IACX;AACJ;;AAEA;;+CAE+C;;AAE/C;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI;;QAEI,iCAAiC;IACrC;AACJ;;AAEA;;IAEI;;QAEI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;;iDAEiD;;AAEjD,cAAc;AACd;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,QAAQ;AACR;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,WAAW;AACX;;;;;IAKI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;;IAEI,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;;IAEI,2BAA2B;AAC/B;;AAEA,aAAa;AACb;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;;IAEI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;IAEI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;iDAEiD;;AAEjD,cAAc;AACd;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,QAAQ;AACR;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,WAAW;AACX;;;;;IAKI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;;IAEI,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;;IAEI,2BAA2B;AAC/B;;AAEA,aAAa;AACb;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;AACxB","sourcesContent":["\n\n/* ESG 2025 Scoped Container Reset & Base Styles */\n.esg-main-container *,\n.esg-container *,\n.esg-section-wrapper *,\n.esg-header-sticky *,\n.esg-category-banner * {\n    box-sizing: border-box;\n}\n\nhtml {\n    scroll-behavior: smooth;\n    scroll-padding-top: 90px;\n}\n\n.esg-main-container,\n.esg-container {\n    font-family: 'Noto Sans KR', sans-serif;\n    color: #333;\n    background-color: #fcfdfe;\n    line-height: 1.6;\n}\n\n/* ESG Main Container */\n.esg-main-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px 20px 80px 20px;\n}\n\n.esg-section-wrapper {\n    margin-bottom: 40px;\n    position: relative;\n}\n\n/* Navigation Bar */\n.esg-header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-bottom: 1px solid #e2e8f0;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\n.esg-nav-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 70px;\n}\n\n.esg-brand {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 20px;\n    font-weight: 800;\n    color: #1b458f;\n    text-decoration: none;\n}\n\n.esg-brand-badge {\n    background: linear-gradient(135deg, #1b458f 0%, #2e7d32 100%);\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3px 8px;\n    border-radius: 12px;\n    text-transform: uppercase;\n}\n\n.esg-nav-tabs {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    list-style: none;\n}\n\n.esg-tab-button {\n    background: transparent;\n    border: none;\n    padding: 10px 16px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #64748b;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.esg-tab-button:hover {\n    color: #1b458f;\n    background-color: #f1f5f9;\n}\n\n.esg-tab-button.active {\n    color: #ffffff;\n    background-color: #1b458f;\n    box-shadow: 0 2px 8px rgba(27, 69, 143, 0.25);\n}\n\n.esg-tab-button.active.tab-e {\n    background-color: #2e7d32;\n    box-shadow: 0 2px 8px rgba(46, 125, 50, 0.25);\n}\n\n.esg-tab-button.active.tab-s {\n    background-color: #e65100;\n    box-shadow: 0 2px 8px rgba(230, 81, 0, 0.25);\n}\n\n.esg-tab-button.active.tab-g {\n    background-color: #1b458f;\n    box-shadow: 0 2px 8px rgba(27, 69, 143, 0.25);\n}\n\n/* Category Header Banner */\n.esg-category-banner {\n    margin: 40px 0 30px 0;\n    padding: 24px 30px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: white;\n}\n\n.esg-category-banner.banner-e {\n    background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%);\n}\n\n.esg-category-banner.banner-s {\n    background: linear-gradient(135deg, #f57c00 0%, #e65100 100%);\n}\n\n.esg-category-banner.banner-g {\n    background: linear-gradient(135deg, #1b458f 0%, #0d2757 100%);\n}\n\n.esg-category-banner h2 {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.esg-category-banner p {\n    font-size: 15px;\n    opacity: 0.9;\n    margin: 4px 0 0 0;\n}\n\n/* Mobile Responsiveness */\n@media screen and (max-width: 768px) {\n    .esg-nav-container {\n        flex-direction: column;\n        height: auto;\n        padding: 12px 16px;\n        gap: 12px;\n    }\n\n    .esg-nav-tabs {\n        width: 100%;\n        overflow-x: auto;\n        padding-bottom: 4px;\n        white-space: nowrap;\n    }\n\n    .esg-tab-button {\n        font-size: 13px;\n        padding: 8px 12px;\n    }\n\n    .esg-main-container {\n        padding: 10px 10px 40px 10px;\n    }\n}\n\n.esg-highlight-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 50px;\n    row-gap: 0;\n}\n\n.esg-item {\n    display: flex;\n    gap: 20px;\n    align-items: flex-start;\n    padding: 20px 0;\n    border-bottom: 1px solid #e0e0e0;\n    box-sizing: border-box;\n}\n\n/* 숫자 폰트 크기 및 스타일 명확히 고정 */\n.esg-num {\n    font-size: 46px !important;\n    font-weight: 700 !important;\n    line-height: 1 !important;\n    min-width: 55px !important;\n}\n\n.esg-content h4 {\n    font-size: 20px !important;\n    font-weight: 700 !important;\n    margin: 0 0 8px 0 !important;\n    word-break: keep-all !important;\n}\n\n.esg-content p {\n    font-size: 16px !important;\n    color: #555555 !important;\n    line-height: 1.55 !important;\n    margin: 0 0 4px 0 !important;\n    word-break: keep-all !important;\n}\n\n.esg-content p:last-child {\n    margin-bottom: 0 !important;\n}\n\n/* 모바일 반응형 */\n@media screen and (max-width: 768px) {\n    .esg-highlight-grid {\n        grid-template-columns: 1fr !important;\n        column-gap: 0 !important;\n    }\n}\n\n/*\n     * ESG2025 CSS — 통합 스타일\n     * 대제목(h3): 20px | 본문(p/li/div): 15px | 캡션/부가설명(span): 13px\n     */\n\n/* === 기본 레이아웃 === */\n.esg-main-container .esg,\n.esg-container .esg {\n    max-width: 100% !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.esg-header {\n    color: #f57c00;\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 8px;\n}\n\n.esg-title {\n    font-size: 40px;\n    font-weight: 700;\n    margin-bottom: 16px;\n}\n\n.esg-subtitle {\n    font-size: 26px;\n    font-weight: 700;\n    margin-top: 10px;\n    margin-bottom: 40px;\n}\n\n/* === 섹션 === */\n.esg-section {\n    margin-top: 20px;\n    margin-bottom: 60px;\n}\n\n.esg-section>p {\n    margin-bottom: 20px;\n}\n\n.esg-section hr {\n    margin: 40px 0;\n    border-top: 1px dashed #ccc;\n    border-bottom: none;\n    border-left: none;\n    border-right: none;\n}\n\n/* === 폰트 크기 기준 === */\n/* 섹션/블록 대제목 */\n.esg h3,\n.esg-section h3 {\n    font-size: 20px;\n    font-weight: 700;\n}\n\n/* 소제목 */\n.esg-section h4,\n.esg-left-col h4 {\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 8px;\n}\n\n/* 본문 텍스트 */\n.esg p,\n.esg li,\n.esg div,\n.esg-section p,\n.esg-section li,\n.esg-left-col p {\n    font-size: 15px;\n}\n\n/* 이미지 캡션 및 부가 설명 */\n.esg>span,\n.esg span,\n.esg-section span,\n.caption {\n    font-size: 13px;\n    color: #727272;\n}\n\n.caption {\n    text-align: center;\n    color: #2e7d32;\n    margin-top: 5px;\n}\n\n/* === 이미지 그리드 === */\n.esg-img {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 20px;\n    justify-content: center;\n    align-items: center;\n    width: 100% !important;\n}\n\n.esg-img img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n    margin: 0 !important;\n}\n\n.esg-section .esg-img {\n    margin-top: 20px;\n}\n\n.esg-section .esg-img img {\n    width: 100%;\n}\n\n/* === 플렉스 텍스트 레이아웃 === */\n.esg-text {\n    margin-top: 0;\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    margin: 40px 0;\n    flex: 1;\n}\n\n.esg-img-list {\n    display: flex;\n    gap: 10px;\n}\n\n/* === 반응형 === */\n@media screen and (max-width: 768px) {\n    .esg-text {\n        flex-direction: column;\n    }\n\n    .esg-img-list {\n        justify-content: flex-start;\n    }\n\n    .esg-img img {\n        width: 100%;\n        height: auto;\n        object-fit: contain;\n    }\n\n    .esg-text h3 {\n        font-size: 20px;\n        margin-bottom: 12px;\n    }\n\n    .esg-text p {\n        line-height: 1.6;\n    }\n\n    .esg-img-list {\n        display: flex;\n        gap: 12px;\n        flex: 1;\n        justify-content: flex-end;\n    }\n\n    .esg-img {\n        flex: 1;\n    }\n}\n\n/* ==========================================\n * ESG2025 WordPress Layout Style\n * ========================================== */\n\n.esg-container {\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    box-sizing: border-box;\n}\n\n/* 좌우 2컬럼 레이아웃 */\n.esg-grid-layout {\n    display: flex;\n    gap: 30px;\n    align-items: stretch;\n    /* 오른쪽 이미지가 왼쪽 콘텐츠 높이에 맞춰 늘어남 */\n    margin-top: 20px;\n    margin-bottom: 60px;\n}\n\n/* 왼쪽 콘텐츠 칼럼 (제목 + 텍스트 + 그래프) */\n.esg-left-col {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.esg-left-col h4 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #3b5998;\n    /* 이미지 레이아웃의 헤더 색상 반영 */\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n\n.esg-left-col p {\n    font-size: 15px;\n    line-height: 1.65;\n    color: #333333;\n    margin-bottom: 20px;\n}\n\n/* 그래프 이미지 스타일 */\n.esg-graph-box {\n    margin-top: 10px;\n    width: 100%;\n}\n\n.esg-graph-box img {\n    width: 100%;\n    height: auto;\n    display: block;\n    border: 1px solid #e0e0e0;\n}\n\n/* 오른쪽 이미지 칼럼 */\n.esg-right-col {\n    flex: 1;\n    display: flex;\n}\n\n.esg-right-col img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    /* 영역 전체를 꽉 채우도록 설정 */\n    display: block;\n    border-radius: 2px;\n}\n\n/* 반응형 모바일 설정 */\n@media screen and (max-width: 992px) {\n    .esg-grid-layout {\n        flex-direction: column;\n    }\n\n    .esg-right-col {\n        min-height: 350px;\n        /* 모바일 전환 시 이미지 높이 확보 */\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    .esg-mrs-img-grid,\n    .esg-recycle-grid {\n        flex-direction: column !important;\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    .esg-img-grid-2,\n    .esg-img-grid-3 {\n        grid-template-columns: 1fr !important;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .esg-cert-grid {\n        flex-direction: column !important;\n        gap: 30px !important;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .esg-bottom-split {\n        flex-direction: column !important;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .esg-5img-grid {\n        grid-template-columns: repeat(2, 1fr) !important;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .esg-page15-grid {\n        flex-direction: column !important;\n    }\n}\n\n/* ============================================\n * ESG2025 Social — 통합 스타일 기준\n * ============================================ */\n\n/* 섹션/블록 대제목 */\n.esg-section h3,\n.esg h3 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #2b4c9b;\n}\n\n/* 소제목 */\n.esg-section h4,\n.esg h4 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #2b4c9b;\n}\n\n/* 본문 텍스트 */\n.esg-section p,\n.esg-section li,\n.esg-section div,\n.esg p,\n.esg li {\n    font-size: 15px;\n}\n\n/* 이미지 캡션 및 부가 설명 */\n.esg-section span,\n.esg span {\n    font-size: 13px;\n}\n\n/* 이미지 border-radius 전역 제거 */\n.esg-section img,\n.esg img {\n    border-radius: 0 !important;\n}\n\n/* 섹션 상하 여백 */\n.esg-section {\n    padding-top: 40px;\n    padding-bottom: 40px;\n}\n\n.esg-main-container section.esg,\n.esg-container section.esg {\n    padding-top: 40px;\n    padding-bottom: 40px;\n}\n\n/* h3/h4 상단 여백 */\n.esg-section h3,\n.esg h3 {\n    margin-top: 20px !important;\n    margin-bottom: 8px !important;\n}\n\n.esg-section h4,\n.esg h4 {\n    margin-top: 16px !important;\n    margin-bottom: 6px !important;\n}\n\n/* ============================================\n * ESG2025 Governance — 통합 스타일 기준\n * ============================================ */\n\n/* 섹션/블록 대제목 */\n.esg-section h3,\n.esg h3 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #2b4c9b;\n    margin-top: 30px;\n    margin-bottom: 10px;\n}\n\n/* 소제목 */\n.esg-section h4,\n.esg h4 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #2b4c9b;\n    margin-top: 25px;\n    margin-bottom: 8px;\n}\n\n/* 본문 텍스트 */\n.esg-section p,\n.esg-section li,\n.esg-section div,\n.esg p,\n.esg li {\n    font-size: 15px;\n}\n\n/* 이미지 캡션 및 부가 설명 */\n.esg-section span,\n.esg span {\n    font-size: 13px;\n}\n\n/* 이미지 border-radius 전역 제거 */\n.esg-section img,\n.esg img {\n    border-radius: 0 !important;\n}\n\n/* 섹션 상하 여백 */\n.esg-section {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n}\n\n.esg-main-container section.esg,\n.esg-container section.esg {\n    padding-top: 40px;\n    padding-bottom: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"esg-main-container": `NjNeaco9pT2mMVtjvILt`,
	"esg-container": `doKNNRaKYNqolhoS71KY`,
	"esg-section-wrapper": `EmEbPptjAZccLR6PE6JQ`,
	"esg-header-sticky": `UXF2y4BdHYvb8F7COXTd`,
	"esg-category-banner": `iEEDyLFKEESTjWhHWIMV`,
	"esg-nav-container": `b_bPl39pd46fGG9ur5UF`,
	"esg-brand": `PLOd8R_ahobqzEIAEj4f`,
	"esg-brand-badge": `ttacMyPbbzuWtvDZaRN3`,
	"esg-nav-tabs": `ho3ZpUl9YKG4bydIumSw`,
	"esg-tab-button": `voiWt6LKIQLvHsNfLwtI`,
	"active": `hXBcTCNFIlq1Z55KAKWQ`,
	"tab-e": `XQoMOpNStr3oOZDAt_DZ`,
	"tab-s": `xiCWRl5JAriZJTpUIv_m`,
	"tab-g": `RtNab_UAcUFeGYhk3RTs`,
	"banner-e": `ilP2VJMhq_nupwpjsosK`,
	"banner-s": `GEVcz5CGC2FBCgbo8dym`,
	"banner-g": `DGhO1SqUyFj0kQPy0CQl`,
	"esg-highlight-grid": `tB_zs7vI1DMhL4PUEFoM`,
	"esg-item": `t8Swbqs5Kr4TUHE4fmJl`,
	"esg-num": `VCy6RldNqQLtamxwzOJ3`,
	"esg-content": `zqzZh6CT2PRsK_widcKI`,
	"esg": `U9LQuJB1rawoRb7WlqWZ`,
	"esg-header": `rXE8ouP9R8tw4qVuYA02`,
	"esg-title": `lMYl5KSyohB8jQFVyFyT`,
	"esg-subtitle": `Tr88lkDuOXjUj2nQYWXY`,
	"esg-section": `nUep5e5mWSIHfmwTteZs`,
	"esg-left-col": `a2nrqCXYBwefhCrTin2R`,
	"caption": `YMCfyIntkNdw1x5inljQ`,
	"esg-img": `NpK92JSzlMsYxSSWKquX`,
	"esg-text": `zQ1cOKIH4bVCzildyUOl`,
	"esg-img-list": `LUqzsQhwbdbap5V72tun`,
	"esg-grid-layout": `A1CozaXTET1mGIP1bhQh`,
	"esg-graph-box": `r5Gr86ApQNiFdZHnkzzL`,
	"esg-right-col": `g3DCX3QKOrSp8QCoQVkS`,
	"esg-mrs-img-grid": `UET36Lsvp5ZOl68RkTyd`,
	"esg-recycle-grid": `q6ii17KgzQNz5zI7oXR0`,
	"esg-img-grid-2": `ZreuXc2YbgrTpUNMU0rW`,
	"esg-img-grid-3": `yMo7iWTqN34TptJQDzgw`,
	"esg-cert-grid": `RbBz3ximQOoZfzCuNSbk`,
	"esg-bottom-split": `_ViBHzTZ4B9GqNWJ_eA0`,
	"esg-5img-grid": `r0gjU4j9aHv3wT9eyesH`,
	"esg-page15-grid": `t9rm8rL1AO8GglQ4NB9K`
};
export default ___CSS_LOADER_EXPORT___;
